export interface SimilarityMonth {
  value: number;
  abbr: string;
  full: string;
}

const MONTHS: SimilarityMonth[] = [
  { value: 1, abbr: 'Jan', full: 'Janeiro' },
  { value: 2, abbr: 'Fev', full: 'Fevereiro' },
  { value: 3, abbr: 'Mar', full: 'Março' },
  { value: 4, abbr: 'Abr', full: 'Abril' },
  { value: 5, abbr: 'Mai', full: 'Maio' },
  { value: 6, abbr: 'Jun', full: 'Junho' },
  { value: 7, abbr: 'Jul', full: 'Julho' },
  { value: 8, abbr: 'Ago', full: 'Agosto' },
  { value: 9, abbr: 'Set', full: 'Setembro' },
  { value: 10, abbr: 'Out', full: 'Outubro' },
  { value: 11, abbr: 'Nov', full: 'Novembro' },
  { value: 12, abbr: 'Dez', full: 'Dezembro' },
];

export default MONTHS;
